import { observer } from "mobx-react-lite";
import { Center, Flex, FlexProps } from "@chakra-ui/react";

import { toolbarStore, useSelecting } from "@noli/business";

import "./UploaderPanel.scss";
import { genBlock } from "@/utils/bem";
import { UploadButton } from "@/modules/editor/components/Uploader/Button";

const block = genBlock("c-uploader-panel");

function UploaderPanel(props: FlexProps) {
  const type = useSelecting("raw").type;

  if (type !== "none" || toolbarStore.inBrushMode) {
    return null;
  }

  return (
    <Flex className={block()} w="100%" direction="column" {...props}>
      <Center pt="24px">
        <UploadButton variant="outline" className={block({ e: "upload" })} />
      </Center>
    </Flex>
  );
}

export default observer(UploaderPanel);
